const FADEIN_DELAY = 270;
const FADEOUT_DELAY = 120;

const loadChatbot = ( $chatbot ) => {
  if ( typeof $chatbot !== 'object' || $chatbot.length <= 0 ) {
    return;
  }

  $chatbot.addClass( 'show' ).fadeIn();
};

const triggerStart = ( $chatWindow ) => {
  $chatWindow.find( 'iframe .chat__start .mat-primary' ).trigger( 'click' );
  $chatWindow.find( 'iframe .chat__start .mat-primary' ).click();
};

const handleChatbotClick = ( $chatbotWrapper ) => {
  if ( typeof $chatbotWrapper !== 'object' || $chatbotWrapper.length <= 0 ) {
    return;
  }
  let $chatbotWindow = $chatbotWrapper.find( '.chatbot-window__wrapper' );
  let $chatbotBadge = $chatbotWrapper.find( '.chatbot-badge' );
  let $chatbotClose = $chatbotWrapper.find( '.chatbot-close' );

  $chatbotBadge.on( 'click', function() {
    setTimeout( () => {
      $chatbotWindow.addClass( 'expand' );
      setTimeout( () => {
        $chatbotClose.removeClass( 'hide-icon' ); // Chat close icon
      }, 50 );
      triggerStart( $chatbotWindow );
    }, FADEIN_DELAY );
    $chatbotBadge.addClass( 'hide-badge' ); // Chat window
  });

  $chatbotClose.on( 'click', function() {
    $( this ).addClass( 'hide-icon' );
    $chatbotWindow.removeClass( 'expand' );
    setTimeout( () => {
      $chatbotBadge.stop().fadeIn().removeClass( 'hide-badge' );
    }, FADEOUT_DELAY );
  });
};

const adjustBagePosition = ( chatbot ) => {

  let $pageFrame = $( '#chr-body-wrapper' );
  let pos = chatbot.data( 'pos' );
  let horizontalVal = chatbot.data( 'horizontal-value' );
  let verticalVal = chatbot.data( 'vertical-value' );
  let horizontalOffset = $pageFrame.offset().left;
  let verticalOffet = $( window ).height() - $pageFrame.height() - $pageFrame.offset().top;

  if ( pos === 'right' ) {
    horizontalOffset = window.innerWidth - $pageFrame.width() - $pageFrame.offset().left;
  }

  let finalValueX = parseFloat( horizontalOffset + horizontalVal );
  let finalValueY = parseFloat( verticalOffet + verticalVal );

  if ( finalValueX < 0 ) {
    finalValueX = horizontalVal;
  }

  if ( finalValueY < 0 ) {
    finalValueY = verticalVal;
  }

  chatbot.css( pos, finalValueX + 'px' );
  chatbot.css( 'bottom', finalValueY + 'px' );
};

$( window ).on( 'load', function() {
  let $chatbot = $( '.chatbot' );

  $chatbot.each( function() {
    adjustBagePosition( $( this ) );
    loadChatbot( $( this ) );

    handleChatbotClick( $( this ) );
  });
});

// Retweaking chatbot position
$( window ).on( 'resize', function() {
  $( '.chatbot' ).each( function() {
    adjustBagePosition( $( this ) );
  });
});
